const gql = String.raw
import * as SEO from './seo'
import * as COMMON from './common'
import { WEBSITE_PARENT_CATEGORY_ID } from '../../utils/siteConfig'

export const ALL_CATEGORIES = gql`
  query AllCategories {
    terms(where: { taxonomies: NEWSCATEGORY }, last: 9999) {
      nodes {
        ... on NewsCategory {
          name
          slug
        }
      }
    }
  }
`

export const ALL_NEWS_BY_SITENAME = gql`
  query AllNewsBySitename($siteName: [String]!, $newsPageId: ID!) {
    posts(
      where: {
        taxQuery: {
          taxArray: { terms: $siteName, taxonomy: NEWSCATEGORY, field: SLUG }
          relation: OR
        }
        orderby: { field: DATE, order: DESC }
      }
      first: 9999
    ) {
      nodes {
        date
        id
        slug
        title

        categories: newsCategories(where: {childOf: ${WEBSITE_PARENT_CATEGORY_ID} }) {
          nodes {
            slug
          }
        }

        ${SEO.SEO_CONFIG}

        signaturePostNewsFields {
          contentBuilder {
            ... on Post_Signaturepostnewsfields_ContentBuilder_Headline {
              fieldGroupName
              text
            }
            ... on Post_Signaturepostnewsfields_ContentBuilder_Text {
              fieldGroupName
              text
            }
            ... on Post_Signaturepostnewsfields_ContentBuilder_Videoembed {
              fieldGroupName
              videoUrl
              videoPoster {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Post_Signaturepostnewsfields_ContentBuilder_Image {
              fieldGroupName
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
          }
          contentImage {
            ${COMMON.IMAGE_FIELDS}
          }
          contentImageCaption

          headerImage {
            ${COMMON.IMAGE_FIELDS}
            id
          }

          headerLogo {
            ${COMMON.IMAGE_FIELDS}
            id
          }
        }
      }
    }

    businessUnits:page(id: $newsPageId, idType:DATABASE_ID) {
      signaturePageCommunity {
        header {
          descriptionText
          descriptionTitle
          headline
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          video {
            mediaItemUrl
          }
        }
      }      

      ${SEO.SEO_CONFIG}
    }
  }
`

export const NEWS_ACF_BY_SLUG = gql`
  query GetPostFieldsBySlug($slug: String) {
    postBy(slug:$slug) {
      ${SEO.SEO_CONFIG}
      
      date
      id
      slug
      title
      
      signaturePostNewsFields {
        contentBuilder {
          ... on Post_Signaturepostnewsfields_ContentBuilder_Headline {
            fieldGroupName
            text
          }
          ... on Post_Signaturepostnewsfields_ContentBuilder_Text {
            fieldGroupName
            text
          }
          ... on Post_Signaturepostnewsfields_ContentBuilder_Videoembed {
            fieldGroupName
            videoUrl
            videoPoster {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Post_Signaturepostnewsfields_ContentBuilder_Image {
            fieldGroupName
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }
        headerImage {
          ${COMMON.IMAGE_FIELDS}
        }
        contentImage {
          ${COMMON.IMAGE_FIELDS}
        }
        contentImageCaption
      }
    }
  }
`
